import { cva, type VariantProps } from 'class-variance-authority';
import type { HTMLAttributes } from 'react';

import { cn } from '@/lib/cn';

export const badgeVariants = cva(
  'inline-flex items-center gap-1.5 rounded-full font-display font-bold leading-none whitespace-nowrap',
  {
    variants: {
      variant: {
        neutral: 'bg-cream-300 text-brown-700',
        primary: 'bg-orange-500 text-white',
        soft: 'bg-orange-100 text-orange-700',
        accent: 'bg-caramel-500 text-white',
        dark: 'bg-brown-900 text-cream-100',
        success: 'bg-whats-500 text-white',
        outline: 'border border-sand-300 bg-white/70 text-brown-700',
        warning: 'bg-warning-500/15 text-brown-800',
      },
      size: {
        sm: 'px-2 py-1 text-[11px]',
        md: 'px-3 py-1.5 text-xs',
        lg: 'px-4 py-2 text-sm',
      },
    },
    defaultVariants: { variant: 'neutral', size: 'md' },
  },
);

export interface BadgeProps
  extends HTMLAttributes<HTMLSpanElement>, VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, size, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant, size }), className)} {...props} />;
}
